var React = require('react');

function Checked (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"20","height":"20","rx":"4","fill":"#D7DE25","key":0}),React.createElement("g",{"clipPath":"url(#clip0_1706_344)","key":1},React.createElement("path",{"d":"M16.7063 5.29344C17.0969 5.68406 17.0969 6.31531 16.7063 6.70594L8.70625 14.7059C8.31563 15.0966 7.68438 15.0966 7.29375 14.7059L3.29288 10.7059C2.90237 10.3153 2.90237 9.68406 3.29288 9.29343C3.68344 8.90281 4.31656 8.90281 4.70719 9.29343L7.97188 12.5841L15.2938 5.29344C15.6844 4.90219 16.3156 4.90219 16.7063 5.29344Z","fill":"white"})),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_1706_344"},React.createElement("rect",{"width":"14","height":"16","fill":"white","transform":"translate(3 2)"})))]);
}

Checked.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Checked;

Checked.default = Checked;
